export default __webpack_public_path__ + "static/media/HENNESSY_1.0f21292f.gif";